module.exports = __webpack_public_path__ + "static/img/invoice-inr-payment.15023a2c.svg";